export * from './suggested-match-card.component';
